import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, Tab } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { SIBreadcrumbs } from "app/pages/sales-intelligence/common-components/SIBreadcrumbs/SIBreadcrumbs";
import { integrationMaxWidth } from "app/pages/sales-intelligence/pages/manage-export/style";

export const StyledManagementWrapper = styled.div`
    background-color: ${colorsPalettes.bluegrey[100]};
`;

export const StyledManagementTabsContainer = styled(FlexColumn)`
    margin: 0 auto;
    width: 100%;
    align-self: center;
    ${integrationMaxWidth}
`;

export const StyledManagementHeader = styled(Flex)`
    justify-content: space-between;
    width: 100%;
    height: 32px;
    margin-bottom: 4px;

    ${setFontVariant("h4", colorsPalettes.carbon[400])};
    line-height: 32px;
`;

export const StyledManagementTitle = styled(Flex)`
    ${setFontVariant("h4", colorsPalettes.carbon[400])};
    line-height: 32px;
`;

export const StyledHeader = styled(FlexColumn)`
    width: 100%;
    margin-bottom: 24px;
`;

export const StyledBreadcrumbsContainer = styled.div`
    margin-bottom: 24px;
`;

export const StyledManagementSIBreadcrumbs = styled(SIBreadcrumbs)`
    position: sticky;
    top: 0;
    z-index: 999;
`;

export const StyledExtensionTab = styled(Tab).attrs<{ "data-automation-selected"?: boolean }>(({ selected }) => ({
    "data-automation-selected": selected,
}))`
    &:hover:not(.selected) {
        color: ${colorsPalettes.carbon["400"]};
    }
`;
